var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import React from 'react'
import styled from 'styled-components'
var Wrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  padding: 20px 17px;\n  height: 41px;\n  background-color: #2e343a;\n'],
      ['\n  padding: 20px 17px;\n  height: 41px;\n  background-color: #2e343a;\n']
    ))
)
var Line = styled.div(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      ['\n  width: 100%;\n  height: 1px;\n  background-color: #70839388;\n'],
      ['\n  width: 100%;\n  height: 1px;\n  background-color: #70839388;\n']
    ))
)
export var ODAppSidebarNavSeparator = function (props) {
  return React.createElement(Wrapper, null, React.createElement(Line, null))
}
var templateObject_1, templateObject_2
//# sourceMappingURL=ODAppSidebarNavSeparator.js.map
